import slice, { setFulfillmentProducts } from './fulfillment.slice';
export { setFulfillmentProducts };
export default slice.reducer;
